import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `https://mushroom-tutorial.com${item.href}` : `https://mushroom-tutorial.com${location.pathname}`,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      <nav aria-label="面包屑导航" className="flex items-center text-sm text-foreground-500 py-3 overflow-x-auto whitespace-nowrap">
        {items.map((item, index) => (
          <span key={index} className="flex items-center">
            {index > 0 && (
              <i className="ri-arrow-right-s-line mx-2 text-foreground-400"></i>
            )}
            {item.href && index < items.length - 1 ? (
              <Link to={item.href} className="hover:text-primary-500 transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className={index === items.length - 1 ? 'text-foreground-800 font-medium' : ''}>
                {item.label}
              </span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}